module.exports = __webpack_public_path__ + "static/media/icon-home-3d.cdbc103f.png";